var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralFeatureLikeBlack = function SvgGeneralFeatureLikeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M3.059 12.059 12 21l8.942-8.941a5.27 5.27 0 0 0 1.559-3.753c0-1.417-.552-2.75-1.554-3.752A5.27 5.27 0 0 0 17.195 3a5.27 5.27 0 0 0-3.752 1.554l-1.442 1.442-1.443-1.442A5.27 5.27 0 0 0 6.806 3a5.27 5.27 0 0 0-3.751 1.554A5.27 5.27 0 0 0 1.5 8.306c0 1.415.554 2.748 1.559 3.753m1.056-6.444A3.78 3.78 0 0 1 6.806 4.5c1.016 0 1.973.396 2.691 1.114l2.504 2.503 2.503-2.503a3.78 3.78 0 0 1 2.69-1.114 3.78 3.78 0 0 1 2.692 1.114A3.78 3.78 0 0 1 21 8.307c0 1.014-.398 1.97-1.12 2.692L12 18.879l-7.881-7.881A3.78 3.78 0 0 1 3 8.306c0-1.017.396-1.972 1.115-2.691",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralFeatureLikeBlack;